// ============================================================================
// FACILITATOR CHAT SERVICE
// Frontend API client for facilitator chat operations
// ============================================================================

import { api } from './api';
import { ChatMessage } from '../types';

/**
 * Send a chat message to the facilitator guidance avatar
 */
export async function sendChatMessage(
  sessionId: string,
  message: string
): Promise<ChatMessage> {
  const response = await api.post(`/api/sessions/${sessionId}/facilitator-chat/message`, {
    message
  });
  return response.data;
}

/**
 * Get chat history for a session
 */
export async function getChatHistory(
  sessionId: string,
  limit: number = 50,
  offset: number = 0
): Promise<ChatMessage[]> {
  const response = await api.get(`/api/sessions/${sessionId}/facilitator-chat/history`, {
    params: { limit, offset }
  });
  return response.data;
}

/**
 * Execute a quick action
 */
export async function executeQuickAction(
  sessionId: string,
  actionId: string
): Promise<ChatMessage> {
  const response = await api.post(`/api/sessions/${sessionId}/facilitator-chat/quick-action`, {
    actionId
  });
  return response.data;
}

